var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-list-spec-item"},[_c('v-icon',{staticClass:"flex-grow-0 mr-4"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }